import { render, staticRenderFns } from "./BusinessHandling.vue?vue&type=template&id=d350ab80&scoped=true&"
import script from "./BusinessHandling.vue?vue&type=script&lang=js&"
export * from "./BusinessHandling.vue?vue&type=script&lang=js&"
import style0 from "./BusinessHandling.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BusinessHandling.vue?vue&type=style&index=1&id=d350ab80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d350ab80",
  null
  
)

export default component.exports